import React, { useMemo, useState, useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Modal, Select, DatePicker, Button, Spin, Checkbox } from "antd";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import Table from "../../../core/pagination/Newdatatable";
// import GRAN_LOGO1 from "../Logo/Granules_logo1.png"; // Uncomment when ready
// import { getApiBaseUrl } from "../Config/Config"; // Only for base URL reference (not used here)
import dayjs from "dayjs";
// import Swal from "sweetalert2";

const { Option } = Select;
const { RangePicker } = DatePicker;

// Mock data (replace with real API later)
const mockChecklistData = [
  {
    slno: 1,
    ID: 1,
    FilterId: "MP/GMB/MF/008/01µ/01-24/00",
    ChecklistItem: "Filter housing clean and free of damage",
    Answer: "Yes",
    Stage: "Wash In",
    RecordedAt: "2025-02-18 09:30:00",
    PerformedBy: "27011",
  },
  {
    slno: 2,
    ID: 2,
    FilterId: "MP/GMB/MF/008/01µ/01-24/00",
    ChecklistItem: "Pressure gauge calibrated",
    Answer: "No",
    Stage: "Wash In",
    RecordedAt: "2025-02-18 09:35:00",
    PerformedBy: "27011",
  },
  {
    slno: 3,
    ID: 3,
    FilterId: "MP/GMB/MF/008/01µ/02-24/00",
    ChecklistItem: "No leaks observed during wash",
    Answer: "Yes",
    Stage: "Wash Out",
    RecordedAt: "2025-02-19 14:15:00",
    PerformedBy: "27011",
  },
  {
    slno: 4,
    ID: 4,
    FilterId: "MP/GMB/MF/006/10µ/09-16/00",
    ChecklistItem: "Dryer temperature within range",
    Answer: "Yes",
    Stage: "Dry In",
    RecordedAt: "2025-02-20 10:00:00",
    PerformedBy: "27011",
  },
  {
    slno: 5,
    ID: 5,
    FilterId: "MP/GMB/MF/006/10µ/09-16/00",
    ChecklistItem: "Visual inspection of filter media",
    Answer: "No",
    Stage: "Visual Inspection",
    RecordedAt: "2025-02-21 11:45:00",
    PerformedBy: "27011",
  },
  // Add more mock records as needed
];

const ChecklistReport = () => {
  const [visible, setVisible] = useState(false); // Password modal
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [authLoading, setAuthLoading] = useState(false);
  const [downloadReportLoading, setDownloadReportLoading] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [dataSource, setDataSource] = useState([]);
  const [selectedFilterId, setSelectedFilterId] = useState(0);
  const [selectedChecklistType, setSelectedChecklistType] = useState("");
  const [selectedStages, setSelectedStages] = useState([]);
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(7, "day"),
    dayjs(),
  ]);
  const [showPassword, setShowPassword] = useState(false);

  // Mock filters (replace with real fetch later)
  const [filters] = useState([
    { ID: 1, Lable: "MP/GMB/MF/008/01µ/01-24/00" },
    { ID: 2, Lable: "MP/GMB/MF/008/01µ/02-24/00" },
    { ID: 3, Lable: "MP/GMB/MF/006/10µ/09-16/00" },
  ]);

  const [checklistTypes] = useState([
    { value: "daily", label: "Daily Checklist" },
    { value: "weekly", label: "Weekly Inspection" },
    { value: "pressure", label: "Pressure Check" },
    { value: "visual", label: "Visual Inspection" },
  ]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(mockChecklistData.length);

  const user = JSON.parse(sessionStorage.getItem("user")) || {
    UserName: "Unknown User",
    UserID: null,
  };

  const reportConfig = useMemo(() => {
    const now = dayjs();
    const filename = `checklist_report_${now.format("YYYY-MM-DD_HH-mm-ss")}`;
    return {
      title: "Checklist Report",
      reportType: "Checklist",
      filename,
      columns: [
        // {
        //   title: "Filter ID",
        //   dataIndex: "FilterId",
        //   key: "FilterId",
        //   width: 180,
        // },
        {
          title: "Checklist Item",
          dataIndex: "ChecklistItem",
          key: "ChecklistItem",
        },
        {
          title: "Yes",
          key: "Yes",
          width: 80,
          align: "center",
          render: (_, record) => (
            <Checkbox className="text-success" checked={record.Answer === "Yes"} disabled />
          ),
        },
        {
          title: "No",
          key: "No",
          width: 80,
          align: "center",
          render: (_, record) => (
            <Checkbox checked={record.Answer === "No"} disabled />
          ),
        },
        // { title: "Stage", dataIndex: "Stage", key: "Stage", width: 120 },
        // {
        //   title: "Date / Time",
        //   dataIndex: "RecordedAt",
        //   key: "RecordedAt",
        //   width: 160,
        //   render: (text) =>
        //     text ? dayjs(text).format("DD-MM-YYYY HH:mm") : "NA",
        // },
        {
          title: "Performed By",
          dataIndex: "PerformedBy",
          key: "PerformedBy",
          width: 140,
        },
      ],
    };
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Export to PDF
    </Tooltip>
  );

  // Mock filtering + pagination
  useEffect(() => {
    setLoading(true);

    let filtered = [...mockChecklistData];

    // Filter by Filter ID
    if (selectedFilterId !== 0) {
      const selectedFilter = filters.find((f) => f.ID === selectedFilterId);
      if (selectedFilter) {
        filtered = filtered.filter(
          (item) => item.FilterId === selectedFilter.Lable,
        );
      }
    }

    // Filter by Checklist Type (mock — add real logic later)
    if (selectedChecklistType) {
      filtered = filtered.filter(
        (item) => item.ChecklistType === selectedChecklistType,
      ); // Assuming field exists
    }

    // Filter by Stages
    if (selectedStages.length > 0) {
      filtered = filtered.filter((item) => selectedStages.includes(item.Stage));
    }

    // Filter by Date Range
    const [start, end] = dateRange;
    if (start && end) {
      filtered = filtered.filter((item) => {
        const recordDate = dayjs(item.RecordedAt);
        return (
          recordDate.isAfter(start.subtract(1, "day")) &&
          recordDate.isBefore(end.add(1, "day"))
        );
      });
    }

    // Pagination
    const startIdx = (currentPage - 1) * pageSize;
    const paginated = filtered.slice(startIdx, startIdx + pageSize);

    setDataSource(
      paginated.map((item, idx) => ({
        ...item,
        key: item.ID || idx,
        sno: startIdx + idx + 1,
      })),
    );

    setTotalRecords(filtered.length);

    setLoading(false);
  }, [
    selectedFilterId,
    selectedChecklistType,
    selectedStages,
    dateRange,
    currentPage,
    pageSize,
    filters,
  ]);

  const handleExportPDF = async () => {
    setDownloadReportLoading(true);

    // Use full filtered data for PDF (no pagination limit)
    let fullData = [...mockChecklistData];

    // Apply same filters as table (copy logic from useEffect above)
    if (selectedFilterId !== 0) {
      const selectedFilter = filters.find((f) => f.ID === selectedFilterId);
      if (selectedFilter) {
        fullData = fullData.filter(
          (item) => item.FilterId === selectedFilter.Lable,
        );
      }
    }
    if (selectedChecklistType) {
      fullData = fullData.filter(
        (item) => item.ChecklistType === selectedChecklistType,
      );
    }
    if (selectedStages.length > 0) {
      fullData = fullData.filter((item) => selectedStages.includes(item.Stage));
    }
    if (dateRange[0] && dateRange[1]) {
      fullData = fullData.filter((item) => {
        const d = dayjs(item.RecordedAt);
        return (
          d.isAfter(dateRange[0].subtract(1, "day")) &&
          d.isBefore(dateRange[1].add(1, "day"))
        );
      });
    }

    const doc = new jsPDF({ orientation: "portrait" });
    const pageWidth = doc.internal.pageSize.getWidth();

    // Header
    // doc.addImage(GRAN_LOGO1, "PNG", 10, 10, 15, 15);
    doc.setFontSize(11);
    doc.text("Granules India Limited", 30, 14);
    doc.text("Gagillapur", 30, 20);
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text("Checklist Report", 10, 35);

    autoTable(doc, {
      startY: 45,
      head: [reportConfig.columns.map((c) => c.title)],
      body: fullData.map((item, idx) => [
        idx + 1,
        item.FilterId || "NA",
        item.ChecklistItem || "NA",
        item.Answer === "Yes" ? "✔" : "",
        item.Answer === "No" ? "✔" : "",
        item.Stage || "NA",
        item.RecordedAt
          ? dayjs(item.RecordedAt).format("DD-MM-YYYY HH:mm")
          : "NA",
        item.PerformedBy || "NA",
      ]),
      theme: "grid",
      headStyles: { fillColor: [22, 160, 133], textColor: [255, 255, 255] },
      margin: { top: 45 },
    });

    // Footer on last page
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text(
        `Page ${i} of ${totalPages}`,
        pageWidth - 40,
        doc.internal.pageSize.height - 10,
      );
      if (i === totalPages) {
        const y = doc.internal.pageSize.height - 25;
        doc.text(`Printed by: ${user.UserName}`, 10, y);
        doc.text(
          `Date Range: ${dateRange[0].format("DD-MM-YYYY HH:mm")} - ${dateRange[1].format("DD-MM-YYYY HH:mm")}`,
          10,
          y + 6,
        );
        doc.text(
          `Printed on: ${dayjs().format("DD-MM-YYYY HH:mm:ss")}`,
          10,
          y + 12,
        );
      }
    }

    doc.save(`${reportConfig.filename}.pdf`);
    setDownloadReportLoading(false);
  };
  console.log("Data Source", dataSource);
  const handlePasswordSubmit = async () => {
    if (!password.trim()) {
      setPasswordError("Password is required");
      return;
    }

    setAuthLoading(true);
    setPasswordError("");

    // Mock auth (replace with real LOGIN call later)
    setTimeout(() => {
      if (password === "123456") {
        // Dummy check — replace with real API
        setVisible(false);
        setPassword("");
        handleExportPDF();
      } else {
        setPasswordError("Invalid password");
      }
      setAuthLoading(false);
    }, 1000);
  };

  return (
    <>
      {downloadReportLoading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 2000,
          }}
        >
          <Spin size="large" tip="Generating PDF..." />
        </div>
      )}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item" aria-current="page">
                      {reportConfig.title}
                    </h4>
                  </ol>
                </nav>
                <h6>View and export checklist records</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link
                    to="#"
                    onClick={() => {
                      setVisible(true);
                      setPassword("");
                      setPasswordError("");
                    }}
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="pdf"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card no-search">
            <div className="card-header d-flex justify-content-between flex-wrap gap-3">
              <div className="d-flex gap-3 align-items-center flex-wrap">
                <Select
                  style={{ width: 200 }}
                  value={selectedFilterId}
                  onChange={setSelectedFilterId}
                  placeholder="Select Filter"
                  showSearch
                >
                  <Option value={0}>All Filters</Option>
                  {filters.map((f) => (
                    <Option key={f.ID} value={f.ID}>
                      {f.Lable}
                    </Option>
                  ))}
                </Select>

                <Select
                  style={{ width: 140 }}
                  value={selectedChecklistType}
                  onChange={setSelectedChecklistType}
                  placeholder="Checklist Type"
                  allowClear
                >
                  {" "}
                  <Option value={0}>Check List</Option>
                  {checklistTypes.map((t) => (
                    <Option key={t.value} value={t.value}>
                      {t.label}
                    </Option>
                  ))}
                </Select>

                <Select
                  mode="multiple"
                  style={{ width: 135 }}
                  value={selectedStages}
                  onChange={setSelectedStages}
                  placeholder="Select Stage(s)"
                  allowClear
                >
                  <Option value="Wash In">Wash In</Option>
                  <Option value="Wash Out">Wash Out</Option>
                  <Option value="Dry In">Dry In</Option>
                  <Option value="Dry Out">Dry Out</Option>
                </Select>

                <RangePicker
                  showTime={{ format: "HH:mm" }}
                  format="DD-MM-YYYY HH:mm"
                  value={dateRange}
                  onChange={setDateRange}
                />

                <Button type="primary" onClick={() => setCurrentPage(1)}>
                  Apply
                </Button>
              </div>
            </div>

            <div className="card-body">
              <Table
                columns={reportConfig.columns}
                dataSource={mockChecklistData}
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize,
                  total: totalRecords,
                  onChange: (page, size) => {
                    setCurrentPage(page);
                    setPageSize(size);
                  },
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Password Modal */}
      <Modal
        title="Confirm Password"
        open={visible}
        onCancel={() => {
          setVisible(false);
          setPassword("");
          setPasswordError("");
        }}
        onOk={handlePasswordSubmit}
        confirmLoading={authLoading}
        okText="Verify & Download"
        width={350}
      >
        <div className="mb-3 position-relative">
          <input
            type={showPassword ? "text" : "password"}
            className={`form-control ${passwordError ? "is-invalid" : ""}`}
            placeholder="Enter your password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setPasswordError("");
            }}
          />
          <span
            className={`ti toggle-password position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer ${showPassword ? "ti-eye" : "ti-eye-off"}`}
            onClick={() => setShowPassword(!showPassword)}
          />
          {passwordError && (
            <div className="invalid-feedback d-block">{passwordError}</div>
          )}
        </div>
      </Modal>
    </>
  );
};

// const renderTooltip = (props) => (
//   <Tooltip id="pdf-tooltip" {...props}>
//     Export to PDF
//   </Tooltip>
// );

export default ChecklistReport;
